import React, { FC, ReactNode, useContext, useEffect, useRef } from 'react';
import { NafThemeType } from '@naf/theme';
import { useIsInViewport } from '@hooks/useIsInViewport';
import { ThemeContextAction } from '@lib/ThemeContext';
import * as S from './ColorSection.styles';

interface Props {
  theme: NafThemeType | null;
  children?: ReactNode | ReactNode[];
}

export const ColorSection: FC<Props> = ({ theme, children }) => {
  const ref = useRef(null);
  const isInViewport = useIsInViewport(ref);
  const setContextTheme = useContext(ThemeContextAction);

  useEffect(() => {
    if (isInViewport && theme) {
      if (theme) setContextTheme(theme);
    }
  }, [isInViewport, setContextTheme, theme]);

  return (
    <S.StyledColorSection $isInViewport={isInViewport}>
      <div ref={ref}>{children}</div>
    </S.StyledColorSection>
  );
};
